import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex flex-column flex-wrap flex-sm-nowrap p-0" }
const _hoisted_4 = { class: "card mb-5 mb-xl-10" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title m-0" }
const _hoisted_7 = { class: "fw-boldest m-0" }
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group d-flex flex-wrap" }
const _hoisted_15 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group d-flex flex-wrap" }
const _hoisted_21 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_22 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_24 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_27 = { class: "indicator-progress" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_29 = { class: "card mb-5 mb-xl-10" }
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "card-title m-0" }
const _hoisted_32 = { class: "fw-boldest m-0" }
const _hoisted_33 = { class: "card-body p-9" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_38 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_40 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_41 = { class: "indicator-label" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_43 = { class: "indicator-progress" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.formData.shipment?.tracking_no
                ? _ctx.formData.shipment?.tracking_no
                : "") + " " + _toDisplayString(_ctx.formData.shipment?.tracking_no && _ctx.formData.declaration_import_no
                ? " / "
                : "") + " " + _toDisplayString(_ctx.formData.declaration_import_no), 1)
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.t("customDeclaration.specification")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("customDeclaration.customsDeclarationNo")), 1),
                _createVNode(_component_el_form_item, { prop: "declaration_import_no" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.declaration_import_no,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.declaration_import_no) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("customDeclaration.importDate")), 1),
                _createVNode(_component_el_form_item, { prop: "import_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.import_date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.import_date) = $event)),
                      type: "date",
                      clearable: "",
                      placeholder: _ctx.t('common.pickDate'),
                      style: {"width":"100%"},
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'import_date')
                  ))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("customDeclaration.customsDeclarationDate")), 1),
                _createVNode(_component_el_form_item, { prop: "customs_declaration_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.customs_declaration_date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customs_declaration_date) = $event)),
                      type: "date",
                      clearable: "",
                      placeholder: _ctx.t('common.pickDate'),
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.commonChangeDefaultDate(
                      $event,
                      _ctx.formData,
                      'customs_declaration_date'
                    )
                  ))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("customDeclaration.registrationNumber")), 1),
                _createVNode(_component_el_form_item, { prop: "registration_number" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.registration_number,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.registration_number) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_23,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _createElementVNode("button", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_27, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_28
            ])
          ], 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.t("customDeclaration.declarationProfile")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("customDeclaration.approvalDate")), 1),
                _createVNode(_component_el_form_item, { prop: "approval_date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.formData.approval_date,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.approval_date) = $event)),
                      type: "date",
                      clearable: "",
                      placeholder: _ctx.t('common.pickDate'),
                      style: {"width":"100%"},
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'approval_date')
                  ))
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_39,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _createElementVNode("button", _hoisted_40, [
            _createElementVNode("span", _hoisted_41, [
              _hoisted_42,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_43, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_44
            ])
          ], 512)
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}